import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import * as React from 'react';
import clsx from 'clsx';
import { useTheme } from '@emotion/react';
import { form } from '../assets/styles/utility';
import { generateUUID } from '../helpers/utility';
import ControlWrapper from './ControlWrapper';
import FormGroup from './FormGroup';
import FormFooter from './FormFooter';
import ControlLabel from './ControlLabel';
import { jsx as ___EmotionJSX } from "@emotion/react";
export const StylesInputBase = (theme, props = {}) => [form.base(theme), {
  //  Remove default style in browsers that support `appearance`
  appearance: 'none'
}, // Apply default form styling, except for `file`, `submit`, `reset`, `button` and `image`
!['file', 'submit', 'reset', 'button', 'image'].includes(props.type) && form.input(theme), // Fix the cursor style for Chrome's increment/decrement buttons. For certain `font-size` values of the `input`, it causes the cursor style of the decrement button to change from `default` to `text`.
props.type === 'number' && {
  '&::-webkit-inner-spin-button, &::-webkit-outer-spin-button': {
    height: 'auto'
  }
}, // Remove inner padding and search cancel button in Chrome, Safari and Opera on OS X.
props.type === 'search' && {
  '&::-webkit-search-cancel-button, &::-webkit-search-decoration': {
    appearance: 'none'
  }
}, {
  // 1. Correct the inability to style clickable types in iOS and Safari.
  // 2. Change font properties to `inherit` in Safari.
  '&::--webkit-file-upload-button': {
    appearance: 'button',
    // 1
    font: 'inherit' // 2

  },
  // Remove clear button in IE on inputs
  '&::ms-clear': {
    display: 'none'
  },
  // Removes `box-shadow` for invalid controls in Firefox.
  '&:invalid': {
    boxShadow: 'none'
  }
}, // Provides enough offset for normal offset, required icon, and a small spacer
props.required && {
  paddingRight: form.variables(theme).controlOffset + theme.fontSize['2xsmall'] + theme.space.small
}];
const Input = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    disabled,
    label,
    name,
    type,
    validationMessage,
    explanationMessage,
    required,
    wrapperProps
  } = _ref,
      rest = _objectWithoutProperties(_ref, ["className", "disabled", "label", "name", "type", "validationMessage", "explanationMessage", "required", "wrapperProps"]);

  const theme = useTheme(); // Only regenerate this if the name prop changes

  const id = React.useMemo(() => `${name}-${generateUUID()}`, [name]);
  return ___EmotionJSX(FormGroup, null, ___EmotionJSX(ControlWrapper, _extends({
    required: required,
    error: Boolean(validationMessage),
    disabled: disabled
  }, wrapperProps), label && ___EmotionJSX(ControlLabel, null, label), ___EmotionJSX("input", _extends({
    css: StylesInputBase(theme, {
      type,
      required
    }),
    className: clsx('CK__Input', className),
    name: name,
    id: id,
    ref: ref,
    type: type,
    disabled: disabled
  }, rest))), ___EmotionJSX(FormFooter, {
    explanationMessage: explanationMessage,
    validationMessage: validationMessage
  }));
});
Input.defaultProps = {
  type: 'text'
};
export default Input;